(function ($)
{
    $.widget("ui.News", {
        options:
        {
            UseAjaxContentPagination: false,
            ResultsContainerId: null,
            NavigationUrl: null,
            PageContentId: null,
            ArticleUrl: null,
            SubscribeUrl: null,
            LoadingTitle: 'Loading Article',
            SuccessTitle: 'Article Detail',
            ErrorTitle: 'Error Loading Article',
            LoadingContent: 'Loading News Article.',
            ErrorContent: 'Error loading News Article.'
        },

        _destroy: function ()
        {
        },

        _init: function ()
        {
            const self = this;
            const jElement = $(self.element);

            self.OnInitContent();
        },

        _create: function ()
        {
            const self = this;
            const jElement = $(self.element);

            if (self.options.PageContentId == null)
            {
                return;
            }

            jElement.on(
                'click',
                '.news_rsssubscribe',
                function (aEvent)
                {
                    aEvent.preventDefault();
                    subscribeToNews(FBUtilities.CombinePath(self.options.SubscribeUrl, self.options.PageContentId), '');
                    return false;
                }
            );

            jElement.on('click', '.news_archivetoggle', function (aEvent)
            {
                if (self.options.UseAjaxContentPagination)
                {
                    aEvent.preventDefault();
                    let toggledArchiveFlag = $(this).data('archive-flag') === "archived" ? "current" : "archived";
                    $(this).html($(this).data(toggledArchiveFlag === "archived" ? "current-text" : "archived-text"));
                    $(this).data('archive-flag', toggledArchiveFlag);
                    $(self.element).AjaxContentPagination('ChangePage', 1);
                    return false;
                }
                else
                {
                    return undefined;
                }
            });


            const container = jElement.find(`#${self.options.ResultsContainerId}`);

            if (self.options.UseAjaxContentPagination)
            {
                const normalContainer = container;
                const moreContainer = container;

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `${self.options.NavigationUrl}${self.options.PageContentId}/`,
                        LoadingTitle: "News",
                        NormalContainer: normalContainer,
                        MoreContainer: moreContainer,
                        OnSuccess: function (mode, data, _textStatus, _jqXHR)
                        {
                            self.OnInitContent();
                        },
                        InitialPagerData: self.options.InitialPagerData,
                        RequestDataFunc: function (isNewSearch, isReset)
                        {
                            return {
                                "ArchiveFlag": jElement.find('.news_archivetoggle').data('archive-flag') === "archived",
                                "PageContentId": self.options.PageContentId,
                                "IsNewSearch": isNewSearch === undefined ? false : isNewSearch,
                                "IsReset": isReset === undefined ? false : isReset
                            };
                        },
                        LiveRegionId: self.options.ResultsContainerId
                    });

                $(self.element).AjaxContentPagination('ChangePage', 1);
            }
        },

        OnInitContent: function ()
        {
            const self = this;
            const jElement = $(self.element);

            if (jElement.find('.fbcms_media .fbcms_imagerotator').length > 0)
            {
                jElement.find('.fbcms_media').RotatorManager();
            }

            jElement.find('.vp_share_panel').ShareLink({});

            if (jElement.find('.fbcms_nh_kbnavi').length > 0)
            {
                jElement.find('.fbcms_nh_kbnavi .fbcms_article').ItemFocusManager();
            }
        },

        SelectArticle: function (aArticleId)
        {
            const self = this;
            if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ArticleUrl))
            {
                return;
            }

            const url = `${self.options.ArticleUrl}\${aArticleId}?fco=1`;
            new FBAjaxDialog().Start({
                AjaxUrl: url
                , ExtraDialogClasses: 'fbd_newsarticle'
                , LoadingDialogTitle: self.options.LoadingTitle
                , SuccessDialogTitle: self.options.SuccessTitle
                , ErrorDialogTitle: self.options.ErrorTitle
                , LoadingContent: self.options.LoadingContent
                , ErrorContent: self.options.ErrorContent
            });
        },
    });
})(jQuery);

$(function ()
{
    $('body').on('click', '.appazur-article-link', function (e)
    {
        const self = this;
        e.preventDefault();
        e.stopPropagation();
        const url = $(self).attr('href');
        const title = $(self).data('title');
        const lastScrollTop = $(window).scrollTop();
        $(self).focus();

        new FBAjaxDialog().Start({
            AjaxUrl: '/Core/News/FetchAppazurPost'
            , Data: {url: url, rndm: Math.random()}
            , LoadingDialogTitle: title
            , SuccessDialogTitle: title
            , ErrorDialogTitle: title
            , ExtraDialogClasses: 'appazur-article-dialog'
            , LoadingContent: 'loading...'
            , ErrorContent: 'load error'
            , OnCloseCallback: function ()
            {
                setTimeout(function ()
                {
                    $(self).focus();
                    window.scrollTo(window.scrollX, lastScrollTop);
                }, 10);
            }
        });

        return false;
    });
});
